import * as yup from 'yup';

const blDetailFormSchema = yup.object().shape({
  bl_number: yup.string().optional(),
  bl_date: yup.mixed().optional().nullable(),
  awb_service_name: yup.string().optional()
});

export { blDetailFormSchema };
